<div class="popup-container tlms-popup">
  <header>
    <div class="header" style="display:block">Copy APR Rates</div>
    <button class="close" style="top:-3px" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </header>
  <ng-container>
    <div style="padding: 16px 24px 16px 24px;">
      <div class="col-12" style="width: 100%;">
        <div class="upload">
          <label class="label"> Fiscal Year
            <span style="color:#ff0000">*</span>
          </label>
          <span class="content">
            <mat-form-field appearance="outline" class="fixed-select">
              <mat-select [(ngModel)]="selected_fiscalyear">

                <mat-option disabled>
                  <div
                    style="display: flex; align-items: center; position: sticky; top: 0; background: white; z-index: 2; width: 100%;">
                    <ngx-mat-select-search [formControl]="fiscalYearFilterControl" placeholderLabel="Search Fiscal Year"
                      noEntriesFoundLabel="No match found" [clearSearchInput]="true">
                    </ngx-mat-select-search>
                  </div>
                </mat-option>
                <div style="max-height: 200px; overflow-y: auto;">

                  <mat-option *ngFor="let year of filteredFiscalYears | async" [value]="year">
                    {{ year.label }}
                  </mat-option>
                </div>

              </mat-select>
            </mat-form-field>

          </span>
        </div>
        <div class="upload">
          <label class="label">Target Fiscal Year
            <span style="color:#ff0000">*</span>
          </label>
          <span class="content">
            <input type="number" min="1900" max="9999" maxlength="4" id="targetFY" name="targetFY" required
              class="targetfy-row" [(ngModel)]="targetFY">
          </span>
        </div>
        <label *ngIf="enableError" class="errormsg"> Please fill in the required fields! </label>
      </div>
    </div>
  </ng-container>
  <div class="cfooter d-flex justify-content-between align-items-center popup-footer">
    <button (click)="onNoClick()" class="mCancel"> CANCEL
    </button>
    <button class="costpl-submit" style="display: inline" (click)="saveClick()">
      SAVE
    </button>
  </div>
</div>